var map = {
	"./dialogs/dialogs.ch_CH.js": 5623,
	"./dialogs/dialogs.ch_CHS.js": 60465,
	"./dialogs/dialogs.ch_TW.js": 32469,
	"./dialogs/dialogs.de_DE.js": 95379,
	"./dialogs/dialogs.en_AU.js": 40226,
	"./dialogs/dialogs.en_CA.js": 99094,
	"./dialogs/dialogs.en_MY.js": 14249,
	"./dialogs/dialogs.en_SG.js": 37734,
	"./dialogs/dialogs.en_UK.js": 27828,
	"./dialogs/dialogs.en_US.js": 28081,
	"./dialogs/dialogs.es_ES.js": 572,
	"./dialogs/dialogs.fr_CA.js": 38544,
	"./dialogs/dialogs.fr_FR.js": 51761,
	"./dialogs/dialogs.jp_JP.js": 10584,
	"./dialogs/dialogs.js": 12010,
	"./dialogs/dialogs.kr_KR.js": 21667,
	"./dialogs/dialogs.mobile.js": 24458,
	"./dialogs/dialogs.ru_RU.js": 61349,
	"./fonts.js": 13968,
	"./icons/icons.js": 4651,
	"./langs.js": 25588,
	"./loading/loading.ch_CH.js": 99865,
	"./loading/loading.ch_CHS.js": 84609,
	"./loading/loading.ch_TW.js": 11743,
	"./loading/loading.de_DE.js": 2726,
	"./loading/loading.en_AU.js": 53185,
	"./loading/loading.en_CA.js": 60886,
	"./loading/loading.en_UK.js": 22925,
	"./loading/loading.en_US.js": 41525,
	"./loading/loading.es_ES.js": 67658,
	"./loading/loading.fr_CA.js": 10077,
	"./loading/loading.fr_FR.js": 52224,
	"./loading/loading.jp_JP.js": 29322,
	"./loading/loading.js": 50878,
	"./loading/loading.kr_KR.js": 85797,
	"./loading/loading.mobile.ch_CH.js": 23937,
	"./loading/loading.mobile.ch_CHS.js": 42192,
	"./loading/loading.mobile.ch_TW.js": 44517,
	"./loading/loading.mobile.de_DE.js": 86478,
	"./loading/loading.mobile.en_AU.js": 53294,
	"./loading/loading.mobile.en_CA.js": 45414,
	"./loading/loading.mobile.en_UK.js": 9348,
	"./loading/loading.mobile.en_US.js": 12675,
	"./loading/loading.mobile.es_ES.js": 87083,
	"./loading/loading.mobile.fr_CA.js": 25789,
	"./loading/loading.mobile.fr_FR.js": 87881,
	"./loading/loading.mobile.jp_JP.js": 11603,
	"./loading/loading.mobile.js": 23896,
	"./loading/loading.mobile.kr_KR.js": 21167,
	"./loading/loading.ru_RU.js": 26408,
	"./map/map.js": 27818,
	"./map/map.mobile.js": 91390,
	"./menu/menu.ch_CH.js": 59560,
	"./menu/menu.ch_CHS.js": 66412,
	"./menu/menu.ch_TW.js": 75654,
	"./menu/menu.de_DE.js": 47002,
	"./menu/menu.en_AU.js": 39010,
	"./menu/menu.en_CA.js": 2187,
	"./menu/menu.en_UK.js": 97230,
	"./menu/menu.en_US.js": 33211,
	"./menu/menu.es_ES.js": 78222,
	"./menu/menu.fr_CA.js": 42110,
	"./menu/menu.fr_FR.js": 95424,
	"./menu/menu.jp_JP.js": 73548,
	"./menu/menu.js": 65889,
	"./menu/menu.kr_KR.js": 32111,
	"./menu/menu.mobile.js": 49607,
	"./menu/menu.ru_RU.js": 85320,
	"./scenes/scenes.ch_CH.js": 96208,
	"./scenes/scenes.ch_CHS.js": 80895,
	"./scenes/scenes.ch_TW.js": 96694,
	"./scenes/scenes.de_DE.js": 5857,
	"./scenes/scenes.en_AU.js": 29033,
	"./scenes/scenes.en_CA.js": 89405,
	"./scenes/scenes.en_UK.js": 31033,
	"./scenes/scenes.en_US.js": 49626,
	"./scenes/scenes.es_ES.js": 53971,
	"./scenes/scenes.fr_CA.js": 14023,
	"./scenes/scenes.fr_FR.js": 71352,
	"./scenes/scenes.jp_JP.js": 21503,
	"./scenes/scenes.js": 73344,
	"./scenes/scenes.kr_KR.js": 60076,
	"./scenes/scenes.mobile.js": 8444,
	"./scenes/scenes.ru_RU.js": 9480,
	"./sounds/sounds.js": 85428,
	"./splashscreen/splashscreen.js": 4781,
	"./splashscreen/splashscreen.mobile.js": 79383,
	"./videos/videos.ch_CH.js": 69920,
	"./videos/videos.ch_CHS.js": 1693,
	"./videos/videos.ch_TW.js": 34003,
	"./videos/videos.de_DE.js": 27996,
	"./videos/videos.en_AU.js": 18709,
	"./videos/videos.en_CA.js": 48879,
	"./videos/videos.en_UK.js": 66963,
	"./videos/videos.en_US.js": 94709,
	"./videos/videos.es_ES.js": 33190,
	"./videos/videos.fr_CA.js": 89351,
	"./videos/videos.fr_FR.js": 41342,
	"./videos/videos.jp_JP.js": 66647,
	"./videos/videos.js": 94487,
	"./videos/videos.kr_KR.js": 65529,
	"./videos/videos.mobile.ch_CH.js": 93259,
	"./videos/videos.mobile.ch_CHS.js": 7313,
	"./videos/videos.mobile.ch_TW.js": 55606,
	"./videos/videos.mobile.de_DE.js": 64549,
	"./videos/videos.mobile.en_AU.js": 84421,
	"./videos/videos.mobile.en_CA.js": 9060,
	"./videos/videos.mobile.en_UK.js": 33312,
	"./videos/videos.mobile.en_US.js": 45836,
	"./videos/videos.mobile.es_ES.js": 21969,
	"./videos/videos.mobile.fr_CA.js": 56785,
	"./videos/videos.mobile.fr_FR.js": 20792,
	"./videos/videos.mobile.jp_JP.js": 30759,
	"./videos/videos.mobile.kr_KR.js": 83580,
	"./videos/videos.mobile.ru_RU.js": 46211,
	"./videos/videos.ru_RU.js": 71001
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87134;